import { FormGroup } from '@mui/material';
import type { FC, MouseEvent as ReactMouseEvent } from 'react';

import { SectionTitle, BodyText } from './commonComponents';
import { CookieToggle } from './cookieToggle';

type CookieOptionsProps = {
	preferences: boolean;
	statistics: boolean;
	marketing: boolean;
	togglePreferences: () => void;
	toggleStatistics: () => void;
	toggleMarketing: () => void;
	handleCookieNoticeClick: (e: ReactMouseEvent) => void;
};

export const CookieOptions: FC<CookieOptionsProps> = ({
	preferences,
	statistics,
	marketing,
	togglePreferences,
	toggleStatistics,
	toggleMarketing,
	handleCookieNoticeClick,
}) => (
	<FormGroup>
		<SectionTitle variant="h5" style={{ marginTop: '20px' }}>
			Cookies that we use to make your visit more personal
		</SectionTitle>
		<BodyText variant="subtitle1" style={{ marginTop: 0 }}>
			These cookies allow optional features or services to work. Our website will still work without them.{' '}
			<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
				More about these cookies
			</span>
			.
		</BodyText>
		<CookieToggle checked={preferences} onChange={togglePreferences} dataTestid="preferences" />

		<SectionTitle variant="h5">Cookies that help us improve our website</SectionTitle>
		<BodyText variant="subtitle1" style={{ marginTop: 0 }}>
			These cookies help us understand how people use our website. We can then use this data to improve how our website
			works.{' '}
			<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
				More about these cookies
			</span>
			.
		</BodyText>
		<CookieToggle checked={statistics} onChange={toggleStatistics} dataTestid="statistics" />

		<SectionTitle variant="h5">Cookies that support our marketing</SectionTitle>
		<BodyText variant="subtitle1" style={{ marginTop: 0 }}>
			We and our partners use these cookies to understand what you’re interested in on our website and on social media.
			This is so we or our partners can personalise our marketing to you.{' '}
			<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleCookieNoticeClick}>
				More about these cookies
			</span>
			.
		</BodyText>
		<CookieToggle checked={marketing} onChange={toggleMarketing} dataTestid="marketing" />
	</FormGroup>
);
